import actionCreatorFactory from 'typescript-fsa'

import { GooglePost } from '@3m5/sm_publish-frontend-api/models'
import { GetGooglePageFeedRequest } from '@3m5/sm_publish-frontend-api'

const actionCreator = actionCreatorFactory('LOGIN')

/*
 * Actions
 */
export const getGooglePageFeedInitiated = actionCreator<GetGooglePageFeedRequest>('GET_GOOGLE_PAGE_FEED_INITIATED')
export const getGooglePageFeed = actionCreator.async<GetGooglePageFeedRequest, GooglePost[]>('GET_GOOGLE_PAGE_FEED')
